import {
    CANCEL_BOOKING,
    BOOKING_UPDATED,
    CHECK_OUT_BOOKING,
    CHECK_IN_BOOKING,
    UPDATE_BOOKING_TIMES,
    EDIT_BOOKING_TIME_CLICKED
} from '../constants';

export const cancelBooking = (id, staticUId) => {
    return {
        type: CANCEL_BOOKING,
        id,
        staticUId,
    };
};

export const checkOutBooking = (id, staticUId) => {
    return {
        type: CHECK_OUT_BOOKING,
        id,
        staticUId,
    };
};

export const checkInBooking = (id, staticUId) => {
    return {
        type: CHECK_IN_BOOKING,
        id,
        staticUId,
    };
};

export const bookingUpdated = (booking) => {
    return {
        type: BOOKING_UPDATED,
        booking,
    };
};

export const updateBookingTimes = (versionedUId, staticUId, startTime, endTime) => {
    return {
        type: UPDATE_BOOKING_TIMES,
        versionedUId,
        staticUId,
        startTime,
        endTime,
    };
};

export const clickEditBookingTime = (staticUId, versionedUId) => {
    return {
        type: EDIT_BOOKING_TIME_CLICKED,
        staticUId,
        versionedUId,
    };
};



// WEBPACK FOOTER //
// ./scripts/actions/bookings.js